import { colors } from 'theme';
import { Space, Typography } from 'antd';
import { StopFilled, WarningFilled } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';

type Severity = 'warning' | 'danger';

type Props = {
    code: string;
    description: string;
    severity?: Severity;
    /** Where in the declaration the error belongs, e.g. "House Consignment 1 | Item 2". */
    location?: string;
    onSeeDetails: () => void;
};

const NotificationsList = ({ code, description, severity = 'warning', location, onSeeDetails }: Props) => {
    const isDanger = severity === 'danger';

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', gap: 32, alignItems: 'flex-start' }}>
            <Space style={{ color: isDanger ? 'var(--error-normal)' : colors.action }}>
                {isDanger ? (
                    <StopFilled style={{ color: 'inherit' }} />
                ) : (
                    <WarningFilled style={{ color: 'inherit' }} />
                )}
                <Typography.Text style={{ color: 'inherit', fontWeight: 600 }}>{code}</Typography.Text>
            </Space>
            <div>
                {location && (
                    <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                        {location}
                    </Typography.Text>
                )}
                <Typography.Text>{description}</Typography.Text>
            </div>

            <Button type="link" style={{ color: 'var(--brand-6)' }} onClick={onSeeDetails}>
                See Details
            </Button>
        </div>
    );
};

export default NotificationsList;
